//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { server } from "@/services/constants";
import api from "@/services/api";
import Hashids from "hashids";
import unity from "@/unity/unity";
import PDFCaseProgress from "@/utils/pdfClientTimeLine";

import moment from "moment";
export default {
    name: "ClientTimeLine",

    data() {
        return {
            main_id: "",
            currenyear: new Date().getFullYear(),
            caseInfo: {
                // caseNo: "CAS-2026-0012",
                // client: "ABC Trading Sdn. Bhd.",
                // caseType: "Company Registration",
                // status: "In Progress",
                // lastUpdated: "14 May 2026, 10:30 AM",
            },

            latestUpdate: {
                // message:
                //     "We have reviewed the submitted documents and are currently preparing the draft for internal review.",
                // date: "14 May 2026, 10:30 AM",
            },

            timelineData: [
                // {
                //     status: "In Progress",
                //     status_time: "15/05/2026 09:30 AM",
                //     status_note: "Work on this request has started and is currently being processed by the assigned team.",
                //     worker: "John Doe"
                // },

            ]
        };
    },

    async mounted() {
        await this.initPage();
        this.$hideLoader();
    },
    methods: {
        async initPage() {
            this.$showLoader();

            const encodedId = this.$route.params.id;

            const hashids = new Hashids("my-secret-salt", 8);

            const decoded = hashids.decode(encodedId);

            this.main_id = decoded[0];

            await this.loaddataMainCase();
            await this.loaddataTimelineVisibility();
        },
        async loaddataMainCase() {


            const resultappointment = await api.getgetTimelineDataDetail({
                params: {
                    module_name: this.$route.query.module_name,
                    case_id: Number(this.main_id),
                }
            })

            if (resultappointment.data && resultappointment.data.length > 0) {

                this.caseInfo = resultappointment.data[0];
            }


        },
        async loaddataTimelineVisibility() {
            const result_timeline_visibility = await api.getgetClientTimelineHistoryShowVisibility({
                params: {
                    module_name: this.$route.query.module_name,
                    case_id: Number(this.main_id),
                }
            })
            if (result_timeline_visibility.data && result_timeline_visibility.data.length > 0) {
                this.timelineData = result_timeline_visibility.data;

                this.latestUpdate.message = result_timeline_visibility.data[0].status_note;
                this.latestUpdate.date = result_timeline_visibility.data[0].status_time;

                this.caseInfo.status = result_timeline_visibility.data[0].status;
                this.caseInfo.lastUpdated = result_timeline_visibility.data[0].status_time;
            }

        },
        exportToPdf() {
            const data = {
                caseInfo: this.caseInfo,
                latestUpdate: this.latestUpdate,
                timelineData: this.timelineData,
            };

            // ตัวนี้จะวิ่งไปเรียกโค้ดใหม่ที่เราปรับปรุงในขั้นตอนที่ 2 อัตโนมัติ
            PDFCaseProgress.exportToPDF(data);
        }
    }
};
